import * as _4 from 'lodash4';
import { IAvailableLocation, IContact, IContactAvailableTimes } from '../../../contact_interfaces';
import { ContactsService } from '../../../services/contact_service';
import { ContactToggleService } from '../../../services/contact_toggle_service';

export class ContactDetailController {
  private contact: IContact;
  private availableLocation: IAvailableLocation;
  private termNames: string[];

  constructor(
    private ngContactsService: ContactsService,
    private $window: ng.IWindowService,
    private $state: ng.ui.IStateService,
    private ngContactToggleService: ContactToggleService,
    private ngEmailManagementService: any
  ) {}

  $onInit() {
    this.termNames = _4.uniq(_4.map(this.contact.courses, 'term_name'));
  }

  $onChanges(changes: ng.IChangesObject): void {
    if (_4.isEmpty(changes)) {
      return;
    }

    this.update();
  }

  update(): void {
    this.setAvailableLocation();
    this.termNames = _4.uniq(_4.map(this.contact.courses, 'term_name'));
  }

  isCallButtonDisabled(): boolean {
    return _4.isEmpty(_4.get(this, 'contact.work_phone', ''));
  }

  isEmailButtonDisabled(): boolean {
    return _4.isEmpty(_4.get(this, 'contact.email', ''));
  }

  showAppointmentButton(): boolean {
    return (
      !_4.isEmpty(_4.get(this, 'contact.availability', [])) && this.ngContactToggleService.toggles.appointmentScheduling
    );
  }

  setAvailableLocation(): void {
    this.availableLocation = _4.groupBy(_4.get(this, 'contact.availability', []), 'location.name');
  }

  getAvailableLocation(): IAvailableLocation {
    return this.availableLocation;
  }

  getLocationForAvailabilityList(availabilityList: IContactAvailableTimes[]): string {
    return _4.get(_4.head(availabilityList), 'location.name', '');
  }

  isAllContactInformationEmpty(): boolean {
    return (
      this.contact &&
      _4.isEmpty(this.contact.email) &&
      _4.isEmpty(this.contact.work_phone) &&
      _4.isEmpty(this.contact.availability) &&
      _4.isEmpty(this.contact.courses)
    );
  }

  get initials(): string {
    return this.ngContactsService.createInitials(this.contact);
  }

  openLink(type: string, link: string): void {
    this.$window.open(`${type}:${link}`, '_system');
  }

  sendEmail(): void {
    if (this.contact) {
      this.ngEmailManagementService.sendEmail({ to: this.contact.email });
    }
  }

  gotoAppointmentScheduling(): void {
    window.location.assign('#/my/host/as3/appointment-new');
  }
}

export class ContactDetailComponent implements angular.IComponentOptions {
  public templateUrl: string = 'capability-ng-resources/src/components/people/contact_detail/contact_detail.html';
  public controller: any = ContactDetailController;
  public controllerAs: string = '$ctrl';
  public bindings: any = {
    contact: '<'
  };
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-resources/src/components/people/contact_detail/contact_detail_controller.ts